import { Component, OnInit } from '@angular/core';
import { WorkshopModel } from '../../../../core/models/workshop/workshop.model';
import { ScheduleStatusModel } from '../../../../core/models/schedule/scheduleStatus';
import { StatusService } from '../../../../core/services/status/status.service';
import { ChecklistModel } from '../../../../core/models/checklist/checklist.model';
import { VehicleMonitor } from '../../../../core/models/vehicle/vehicleMonitor';
import { QuotationService } from '../../../../core/models/quotation/quotation-service.model';
import { CHECKLIST_WORKSHOP } from '../../../../utils/workshop/constants/constants';
import { httpCode } from '../../../../utils/http/constants/constants';
import { SCHEDULE_STATUS } from '../../../../utils/schedule/constants/constants';
import { QuotationResponse } from '../../../../core/models/quotation/quotation-response.model';
import { QuotationScheduleDetailVO } from '../../../../core/models/quotation/quotation-schedule-detail.model';
import { QUOTATION } from '../../../../utils/quotation/constants/constants';
import { ScheduledServicesModel } from '../../../../core/models/schedule/scheduledServicesModel';
import { Router } from '@angular/router';
import { DateHourPipe } from '../../../../shared/pipes/date-hour/date-hour.pipe';
import { DecreaseNamePipe } from '../../../../shared/pipes/name/decreaseName.pipe';
import { HourPipe } from '../../../../shared/pipes/hour/hour.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent, TableComponent, TableElement } from '@components/atoms';
import { ButtonLibComponent } from '@components/atoms';
import { ResizeVerticalTrackerComponent } from '../../../../shared/components/resize-vertical-tracker/resize-vertical-tracker.component';
import { NgIf, NgClass, UpperCasePipe, DatePipe } from '@angular/common';
import { isSourceFordPass } from '@core/utils';
import { AuthService } from '@agenda-customer-ui/data-access';
import { RoutesPath } from '@core/enums';
import { SharedModuleLib } from '../../../../../../shared.module';

interface Tracker {
  completed: boolean,
  inProgress: boolean
}

@Component({
    selector: 'agenda-customer-ui-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgClass,
        ResizeVerticalTrackerComponent,
        DialogComponent,
        TableComponent,
        ButtonLibComponent,
        SharedModuleLib,
        UpperCasePipe,
        DatePipe,
        TranslateModule,
        HourPipe,
        DecreaseNamePipe,
        DateHourPipe,
    ],
})
export class StatusComponent implements OnInit {
  dialogChange = false;
  loadDeliveryDate = true;

  scheduleStatusModels!: ScheduleStatusModel[];
  scheduleStatusModel!: ScheduleStatusModel;
  workshopModel!: WorkshopModel[];
  checklistModel!: ChecklistModel;
  vehicleServicesMonitor!: VehicleMonitor[];

  scheduleDate = '';
  checkInHour = 9999;
  advisorName = '';
  status!: number[];

  quotationSchedule!: QuotationScheduleDetailVO;
  quotationRevision!: QuotationResponse;

  vin!: string;
  nationalId!: string;
  country!: string;
  verifySchedule!: number;

  statusLoad = false;
  schedule = 0;
  error = false;

  deliveryTracker!: Tracker;
  revisionTracker!: Tracker;
  basicTestsTracker!: Tracker;
  cleaningTracker!: Tracker;

  schedulesByVin: ScheduledServicesModel[] = [];
  quotationScheduleVO!: QuotationScheduleDetailVO;

  isFordPass!: boolean;

  checklistModels!: ChecklistModel[];
  checklistStatus!: number;
  InProgressChecklist_1 = false;
  completedChecklist_1 = false;
  startServiceDate = '';
  testDate = '';
  cleaningDate = '';
  finishDate = '';

  constructor(
    private statusService: StatusService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.deliveryTracker = { completed: false, inProgress: false }
    this.revisionTracker = { completed: false, inProgress: false }
    this.basicTestsTracker = { completed: false, inProgress: false }
    this.cleaningTracker = { completed: false, inProgress: false }
    this.quotationRevision = {
      quotation: false,
      quotationRevisionName: '',
      quotationRevisionDate: '',
      quotationDescription: []
    }
  }

  ngOnInit(): void {
    this.vin = this.authService.urlInfo.vin;
    this.country =  this.authService.urlInfo.country;
    this.getScheduledServicesStatusData();
    this.isFordPass = isSourceFordPass(this.authService.urlInfo.source);
  }

  handleDialog() {
    this.dialogChange = !this.dialogChange;
  }

  get quotationDescriptionElements(): TableElement[] {
    return (this.quotationRevision.quotationDescription || []).map((service, index) => ({
      id: index,
      name: service,
      description: '',
    }));
  }

  getScheduledServicesStatusData() {
    this.statusService.getScheduledServicesStatusData(
      this.vin,
      (this.status = [SCHEDULE_STATUS.STATUS_IN_PROGRESS]),
      this.country
      ).subscribe(response => {
      this.deliveryTracker.inProgress = true;
      this.schedule = response.response.length;
      if (response && response.response && response.response.length > 0) {
        this.scheduleStatusModels = response.response as ScheduleStatusModel[];
        this.scheduleStatusModels.sort(function (a, b) {
          return (b.scheduleDate + '-' + b.scheduleHour).localeCompare(
            a.scheduleDate + '-' + a.scheduleHour,
            'en',
            { numeric: true }
          );
        });
        this.scheduleStatusModel = this.scheduleStatusModels[0];
        this.scheduleDate = this.scheduleStatusModel.scheduleDate
        this.checkInHour = this.scheduleStatusModel.checkInHour
        this.advisorName = this.scheduleStatusModel.advisorName
        if (this.scheduleStatusModel.checkInHour) {
          this.deliveryTracker.completed = true;
        } else {
          this.deliveryTracker.inProgress = true;
        }
        this.getStatusWorkshopBySchedule();
        this.getQuotationDetails();
      } else {
        this.loadDeliveryDate = false;
      }
    });
    this.loadDeliveryDate = false;
  }

  getStatusWorkshopBySchedule() {
    this.statusService.getStatusWorkshopBySchedule
    (this.scheduleStatusModel).subscribe(response => {
      this.workshopModel = response.response;
      if(response && response.response.length > 0){
        if(response.response[0].status === CHECKLIST_WORKSHOP.START_SERVICE_BRA ||
          response.response[0].status === CHECKLIST_WORKSHOP.START_SERVICE_ARG ){
          this.revisionTracker.inProgress = true;
        } else if (response.response[0].status === CHECKLIST_WORKSHOP.READY_FOR_DELIVERY_BRA ||
          response.response[0].status === CHECKLIST_WORKSHOP.READY_FOR_DELIVERY_ARG) {
            this.revisionTracker.completed = true;
          } else {
            this.revisionTracker.inProgress = false;
            this.revisionTracker.completed = false;
          }
        }
    });
  }

  getQuotationDetails() {
    this.statusService.getScheduleQuotation(
      this.scheduleStatusModel.advisorId,
      this.scheduleStatusModel.scheduleDate,
      this.scheduleStatusModel.scheduleHour,
      this.scheduleStatusModel.dealerId,
      this.country
      ).subscribe(response => {
        this.quotationSchedule = response.response;
        this.quotationRevision.quotationRevisionDate = this.quotationSchedule.update || '';
        const requestedItems = this.quotationSchedule.requestedItems.services;
        const recommendedItems = this.quotationSchedule.recommendedItems.services;
        if (this.quotationSchedule && response.httpCode === httpCode.OK) {
          if (requestedItems.find((x: QuotationService) => x.serviceType === QUOTATION.SERVICE_TYPE_REVISION)) {
              this.quotationRevision.quotation = true;
              this.quotationRevision.quotationRevisionName = requestedItems.find((x: QuotationService) => x.serviceType === QUOTATION.SERVICE_TYPE_REVISION)?.serviceName || '';
          };
          if (requestedItems.length > 0) {
            requestedItems.forEach((element: QuotationService) => {
              this.quotationRevision.quotationDescription.push(element.serviceName)
            });
          } else if (recommendedItems.length > 0) {
            recommendedItems.forEach((element: QuotationService) => {
              this.quotationRevision.quotationDescription.push(element.serviceName)
            });
          };
        };
      });
  }

  reloadAfterCanceledSchedule() {
    this.ngOnInit();
  }

  openChecklistSummary(){
    const checklistSummaryData = JSON.stringify(this.scheduleStatusModel);
    sessionStorage.setItem('checklist-summary', checklistSummaryData);
    this.router.navigate([RoutesPath.CHECKLIST_SUMMARY]);
  }
}
